<template>
  <b-tabs
    vertical
    content-class="col-12 col-md-9 mt-1 mt-md-0"
    pills
    nav-wrapper-class="col-md-3 col-12"
    nav-class="nav-left"
  >

  <!-- <b-tab active>
  <template #title>
    <feather-icon
      icon="UserIcon"
      size="18"
      class="mr-50"
    />
    <span class="font-weight-bold">Test</span>
  </template>

  <test
  :userData="userData"
  />
  </b-tab> -->
    <!-- general tab -->
    <!-- <b-tab active>
      <template #title>
        <feather-icon
          icon="UserIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">Umum</span>
      </template>

      <account-setting-general
      :userData="userData"
      />
    </b-tab> -->
    <!--/ general tab -->

     <!-- info -->
    <!-- <b-tab>
      <template #title>
        <feather-icon
          icon="InfoIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">Biodata</span>
      </template>

      <account-setting-information
      :tempUserData="userData"
      />
    </b-tab> -->

    <!-- change password tab -->
    <b-tab>

      <!-- title -->
      <template #title>
        <feather-icon
          icon="LockIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">Password</span>
      </template>

      <account-setting-password />
    </b-tab>

     <b-tab
    v-if="$can('manage','all') && $route.params.id"
    >
      <template #title>
        <feather-icon
          icon="SettingsIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">Hak Akses </span>
      </template>

      <rules
        :adminProcess="true"
      />
    </b-tab>
    <!--/ change password tab -->
  </b-tabs>
</template>

<script>
import { BTabs, BTab } from 'bootstrap-vue'
import AccountSettingGeneral from './AccountSettingGeneral.vue'
import AccountSettingPassword from './AccountSettingPassword.vue'
import AccountSettingInformation from './AccountSettingInformation.vue'
import Rules from './Rules.vue'
import Test from './Test.vue'

import {
  getUserDetail,
} from '@/connection-api/master'

export default {
  components: {
    BTabs,
    BTab,
    AccountSettingGeneral,
    AccountSettingPassword,
    AccountSettingInformation,
    Rules,
    Test,
    // AccountSettingSocial,
    // AccountSettingNotification,
  },
  data() {
    return {
      options: {},
      userData: {},
      biodata: {},
      kotaOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Kota --' },
        ],
      },
      logo: require('@/assets/images/logo/logo.png'),
    }
  },
  beforeCreate() {
    //API data
    if(this.$route.params.id)
    {
      getUserDetail(this.$route.params.id)
      .then(response => {
        this.userData = response.data.data;
        if(this.userData.foto === null){
          this.userData.foto = this.logo
        }
      })
      .catch(error => console.log(error));
    }
  },
}
</script>
